import axios from 'axios';
import { useStore } from '../../../store';
import { showMoreCheckout } from './showMoreCheckout';
import { getUrl } from './getUrl';

const store = useStore();

export const getNews = () => {
    store.commit('press/SET_LOADING', true);
    let url = getUrl();

    axios.get(url)
        .then(res => {
            showMoreCheckout(res.data.meta.totalPages);
            store.commit('press/SET_NEWS', res.data.data);
            store.commit('press/SET_LOADING', false);
        })
}
